/**
 * @generated SignedSource<<1b163559b84e3a0b20055401cbc60ec9>>
 * @relayHash 207b783925a75bbb5377f16b7e91a4de
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/537.0.0-2025-11-18T19:15:26.609Z/PdpRespUnavailableLayoutEntryQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PdpRespUnavailableLayoutEntryQuery$variables = {
  afterDisplay: boolean;
  afterDisplayAndNotBot: boolean;
  afterDisplayOrBuaSsr: boolean;
  fetchChat: boolean;
  fetchUser: boolean;
  forcedCurrency?: Currency | null;
  guestId?: string | null;
  isTrade: boolean;
  isYouvePurchasedCalloutVariant?: boolean | null;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  priceBookName?: string | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type PdpRespUnavailableLayoutEntryQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly isAuctionEnabled?: boolean | null;
      readonly isSold?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_item" | "findPdpItemReadError_itemRead" | "handlePdpStatuses_item">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_viewer" | "PdpRespUnavailableLayout_viewer">;
  };
};
export type PdpRespUnavailableLayoutEntryQuery = {
  response: PdpRespUnavailableLayoutEntryQuery$data;
  variables: PdpRespUnavailableLayoutEntryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "afterDisplayAndNotBot"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "afterDisplayOrBuaSsr"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchChat"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forcedCurrency"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isYouvePurchasedCalloutVariant"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v12 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v14 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v15 = {
  "alias": "isPdpUrlTranslationEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "translatedPdpUrls"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
},
v16 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    }
  ],
  "type": "ItemReadError",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAuctionEnabled",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v21 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v22 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v23 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "forcedCurrency"
    },
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "microdata",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ogTitle",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceAmount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceCurrency",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageAnnotations",
  "kind": "LinkedField",
  "name": "languageAnnotations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hrefLang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageVersionType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": [
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPriceUponRequest",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingListed",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingNotListed",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingUnlisted",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingMigrated",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNew",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWip",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInternal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = [
  {
    "kind": "Literal",
    "name": "metricTypes",
    "value": [
      "ITEM_LISTING_VIEWS"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeRange",
    "value": "LAST_6_MONTHS"
  }
],
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirectType",
  "kind": "LinkedField",
  "name": "redirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v53/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v59 = [
  (v37/*: any*/),
  (v53/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dealerSince",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v64 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v65 = [
  (v64/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attribution",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v70 = [
  (v69/*: any*/),
  (v55/*: any*/)
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v72 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v73 = [
  (v55/*: any*/),
  (v71/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v78 = [
  (v76/*: any*/),
  (v77/*: any*/)
],
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v78/*: any*/),
  "storageKey": null
},
v80 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v48/*: any*/)
],
v81 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showMakeOffer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v83 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v86 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v91 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v92 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v93 = [
  (v91/*: any*/),
  (v92/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v95 = [
  (v77/*: any*/)
],
v96 = {
  "kind": "Literal",
  "name": "page",
  "value": "pdp"
},
v97 = [
  (v96/*: any*/)
],
v98 = {
  "alias": null,
  "args": (v97/*: any*/),
  "concreteType": "AuctionLot",
  "kind": "LinkedField",
  "name": "relevantAuctionLot",
  "plural": false,
  "selections": [
    (v54/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": "relevantAuctionLot(page:\"pdp\")"
},
v99 = {
  "alias": null,
  "args": (v97/*: any*/),
  "concreteType": "AuctionSolution",
  "kind": "LinkedField",
  "name": "relevantAuctionSolution",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reserveMet",
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": "relevantAuctionSolution(page:\"pdp\")"
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "Hold",
  "kind": "LinkedField",
  "name": "activeHold",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantityDisplay",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentageOff",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPriceLabel",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": (v93/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "privateOfferConvertedAmountList",
      "plural": true,
      "selections": (v78/*: any*/),
      "storageKey": null
    },
    (v101/*: any*/),
    (v102/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateOfferPercentageOff",
      "storageKey": null
    },
    (v90/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerExpirationDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVatIncluded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": [
    (v91/*: any*/),
    (v96/*: any*/)
  ],
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v108 = [
  (v91/*: any*/)
],
v109 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v110 = [
  (v109/*: any*/),
  (v64/*: any*/)
],
v111 = {
  "kind": "Literal",
  "name": "useML",
  "value": true
},
v112 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  (v109/*: any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "INCLUDE"
  },
  (v111/*: any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFurniture",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "pdpMetaItems",
  "kind": "LinkedField",
  "name": "pdpMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topQuery",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        (v53/*: any*/)
      ],
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v53/*: any*/)
          ],
          "storageKey": null
        },
        (v53/*: any*/)
      ],
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStorefrontOnly",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v37/*: any*/),
                (v58/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                (v53/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v77/*: any*/),
    (v76/*: any*/)
  ],
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": [
    (v92/*: any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v21/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v122/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v90/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v124 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v125 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": "mobileTitle",
      "args": (v124/*: any*/),
      "kind": "ScalarField",
      "name": "title",
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v69/*: any*/),
        {
          "alias": "mobileText",
          "args": (v124/*: any*/),
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v58/*: any*/),
        (v117/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v80/*: any*/),
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": (v49/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v53/*: any*/)
  ],
  "storageKey": null
},
v128 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    (v87/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        (v33/*: any*/)
      ],
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v131/*: any*/),
    (v132/*: any*/)
  ],
  "storageKey": null
},
v134 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v135 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": ""
  },
  (v134/*: any*/),
  (v109/*: any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "EXCLUDE"
  },
  (v111/*: any*/)
],
v136 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  },
  (v53/*: any*/)
],
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v138 = [
  (v91/*: any*/),
  (v134/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpRespUnavailableLayoutEntryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespUnavailableLayout_viewer"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PdpHeadBuilder_viewer",
            "selections": [
              (v15/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "findPdpItemReadError_itemRead",
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PdpHeadBuilder_item",
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "kind": "LinkedField",
                        "name": "pdpMeta",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "getLanguageAnnotations_pdpMetaItems",
                            "selections": [
                              (v32/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v36/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": [
                      {
                        "kind": "RootArgument",
                        "name": "forcedCurrency"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "priceBookName"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "userCountryCode"
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "handlePdpStatuses_item",
                        "selections": [
                          (v27/*: any*/),
                          (v37/*: any*/),
                          (v25/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": "relevantAuctionLotRedirect",
                            "args": null,
                            "concreteType": "AuctionLot",
                            "kind": "LinkedField",
                            "name": "relevantAuctionLot",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v20/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": (v47/*: any*/),
                            "concreteType": "MetricDetailType",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": (v49/*: any*/),
                            "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                          },
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v13/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v14/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "PdpRespUnavailableLayoutEntryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isItemReadType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v37/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "kind": "LinkedField",
                        "name": "liveStorefrontProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aboutUsUnbranded",
                            "storageKey": null
                          },
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "establishmentYear",
                            "storageKey": null
                          },
                          {
                            "alias": "headshots",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "photoType",
                                "value": "DEALER_STOREFRONT_HEADSHOT"
                              }
                            ],
                            "concreteType": "Photo",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaAlbum",
                            "kind": "LinkedField",
                            "name": "galleryAlbum",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "kind": "LinkedField",
                                "name": "mediaList",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v55/*: any*/)
                                        ],
                                        "type": "Photo",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v56/*: any*/)
                                        ],
                                        "type": "Video",
                                        "abstractKey": null
                                      },
                                      (v57/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "isRewardsTier2",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listName",
                            "value": "SELLER_REWARDS_2"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListMember",
                        "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "kind": "LinkedField",
                        "name": "tradeAssociations",
                        "plural": true,
                        "selections": [
                          (v37/*: any*/),
                          (v58/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "agreementStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sellerOrderQuantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MCAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCMetricResponseTime",
                                "kind": "LinkedField",
                                "name": "responseTime",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "summaryCopy",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "shippingAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "displayFullCityStateCountry",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "fullCountryName",
                                "value": true
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDistinguished",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTiers",
                        "kind": "LinkedField",
                        "name": "sellerTiers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGoldTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPlatinumTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sellerTierDataNotFound",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "kind": "LinkedField",
                                "name": "aggregatedFeedback",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackQuestionType",
                                    "kind": "LinkedField",
                                    "name": "overallExperience",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mean",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicNoteTotalResults",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v59/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "monthsSinceStartDate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "MONTH"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "timeSinceStartDate",
                        "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "kind": "LinkedField",
                        "name": "sellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Phone",
                        "kind": "LinkedField",
                        "name": "trackedPhone",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneNumber",
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelrySeller",
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v60/*: any*/),
                          {
                            "alias": "dealerDetailsOrderFeedbackPdp",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "feedbackSellerPublicNoteHasText",
                                "value": true
                              },
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 3
                              },
                              {
                                "kind": "Literal",
                                "name": "minimumReviewRating",
                                "value": 4
                              },
                              {
                                "kind": "Literal",
                                "name": "sortBy",
                                "value": "sellerExperienceDesc"
                              }
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "completedDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Transaction",
                                        "kind": "LinkedField",
                                        "name": "transaction",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "buyer",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Profile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                  (v61/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v53/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "kind": "LinkedField",
                                            "name": "shipment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Address",
                                                "kind": "LinkedField",
                                                "name": "shippingAddress",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayState",
                                                    "storageKey": null
                                                  },
                                                  (v62/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "country",
                                                    "storageKey": null
                                                  },
                                                  (v53/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v53/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v53/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "overallExperience",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v63/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "publicNote",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "freetext",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v53/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                          },
                          {
                            "condition": "isYouvePurchasedCalloutVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v65/*: any*/),
                                "concreteType": "BuyerOrderReviewType",
                                "kind": "LinkedField",
                                "name": "buyerOrderReview",
                                "plural": false,
                                "selections": [
                                  (v63/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "image",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pdpUrl",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      (v56/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anchorText",
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  (v66/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      (v68/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v58/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": (v70/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "sitemapLinks",
                    "plural": true,
                    "selections": (v70/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v69/*: any*/),
                      (v55/*: any*/),
                      (v71/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "storyTelling",
                    "args": (v72/*: any*/),
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentHeader",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingModuleCreator",
                            "kind": "LinkedField",
                            "name": "contentCreatorAttribution",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creatorName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "creatorBrowseUrl",
                                "plural": false,
                                "selections": (v73/*: any*/),
                                "storageKey": null
                              },
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentBodyText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browseLink",
                            "plural": false,
                            "selections": (v73/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seoDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "kind": "LinkedField",
                    "name": "pdpDetailsDisplay",
                    "plural": true,
                    "selections": [
                      (v74/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "delimiter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detailDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "detailValues",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPdpDetailValueInterface"
                          },
                          (v74/*: any*/),
                          (v45/*: any*/),
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayDetails",
                            "storageKey": null
                          },
                          (v75/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": [
                                  (v79/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailVersionsValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RingSizeDetail",
                                "kind": "LinkedField",
                                "name": "ringSizes",
                                "plural": true,
                                "selections": (v80/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailRingSize",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAvailable",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v51/*: any*/),
                  (v40/*: any*/),
                  {
                    "alias": "dealerDetailsDisplayInfo",
                    "args": null,
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": (v81/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  (v82/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoVimeo",
                    "kind": "LinkedField",
                    "name": "videoVimeo",
                    "plural": false,
                    "selections": [
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includePlayButton",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "pad",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w100h75"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                      },
                      {
                        "alias": null,
                        "args": (v83/*: any*/),
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": [
                          (v84/*: any*/)
                        ],
                        "storageKey": "fileByVideoSize(size:\"small\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemReviewDocumentList",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemReview",
                        "kind": "LinkedField",
                        "name": "videoReview",
                        "plural": false,
                        "selections": [
                          (v54/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v85/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "kind": "LinkedField",
                    "name": "measurement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "kind": "LinkedField",
                        "name": "convertedMeasurements",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "convertedMeasurements(unit:\"IN\")"
                      },
                      {
                        "alias": "widthDimensions",
                        "args": [
                          (v86/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v80/*: any*/),
                        "storageKey": "display(addLabel:false,fields:[\"width\"])"
                      },
                      {
                        "alias": "heightDimensions",
                        "args": [
                          (v86/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v80/*: any*/),
                        "storageKey": "display(addLabel:false,fields:[\"height\"])"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v75/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v87/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alt",
                        "storageKey": null
                      },
                      (v88/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "kind": "LinkedField",
                    "name": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "credits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "kind": "LinkedField",
                        "name": "centerPosition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "top",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "left",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "kind": "LinkedField",
                        "name": "comparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pixel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inches",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v83/*: any*/),
                    "kind": "ScalarField",
                    "name": "firstPhotoWebPath",
                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                  },
                  {
                    "alias": null,
                    "args": (v72/*: any*/),
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticlesType",
                            "kind": "LinkedField",
                            "name": "supplementaryEditorial",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WordpressArticleType",
                                "kind": "LinkedField",
                                "name": "articles",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publishedDate",
                                    "storageKey": null
                                  },
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WordpressArticleImageType",
                                    "kind": "LinkedField",
                                    "name": "imageUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "full",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subtitle",
                                    "storageKey": null
                                  },
                                  (v84/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "source",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          (v89/*: any*/),
                          (v69/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "ringResizable",
                        "plural": true,
                        "selections": [
                          (v89/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isJewelry",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": "priceType",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "buyerId",
                        "value": ""
                      },
                      {
                        "kind": "Literal",
                        "name": "isTrade",
                        "value": false
                      }
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      (v90/*: any*/)
                    ],
                    "storageKey": "displayPrice(buyerId:\"\",isTrade:false)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "leadTimeDisplay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v93/*: any*/),
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "kind": "LinkedField",
                        "name": "originalConvertedAmountList",
                        "plural": true,
                        "selections": (v78/*: any*/),
                        "storageKey": null
                      },
                      (v79/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "pdpMetaItems",
                    "kind": "LinkedField",
                    "name": "pdpMeta",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v35/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v36/*: any*/),
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v45/*: any*/),
                      (v94/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contemporaryTrackingString",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v22/*: any*/),
                          (v64/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "pdpTrackingVpvParams",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v60/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v93/*: any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v95/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v95/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v95/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2UserVariant",
                        "kind": "LinkedField",
                        "name": "seoAbTestV2List",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "variant",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "testName",
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v98/*: any*/),
                      (v99/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuctionSecondChanceInfo",
                        "kind": "LinkedField",
                        "name": "auctionSecondChanceInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "offerSent",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v100/*: any*/),
                      (v105/*: any*/),
                      (v106/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v88/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v107/*: any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v108/*: any*/),
                            "kind": "ScalarField",
                            "name": "hasRequestedHoldForBuyer",
                            "storageKey": null
                          },
                          (v107/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v108/*: any*/),
                        "kind": "ScalarField",
                        "name": "hasActiveHoldForBuyer",
                        "storageKey": null
                      },
                      (v107/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplayOrBuaSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v100/*: any*/),
                      (v105/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "relevantAuctionLotRedirect",
                        "args": null,
                        "concreteType": "AuctionLot",
                        "kind": "LinkedField",
                        "name": "relevantAuctionLot",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": null
                      },
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": (v47/*: any*/),
                        "concreteType": "MetricDetailType",
                        "kind": "LinkedField",
                        "name": "metrics",
                        "plural": true,
                        "selections": [
                          (v48/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                      },
                      (v50/*: any*/),
                      (v52/*: any*/)
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v57/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": null,
            "args": (v110/*: any*/),
            "concreteType": "BuyerUrgencyInfo",
            "kind": "LinkedField",
            "name": "buyerUrgencyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalConversations",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isPopularSearchesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "alias": "videoUploadToolsFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "videoUploadTools"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"videoUploadTools\")"
          },
          {
            "alias": "sellerItems",
            "args": (v112/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v27/*: any*/),
                      (v106/*: any*/),
                      (v45/*: any*/),
                      (v94/*: any*/),
                      (v115/*: any*/),
                      (v25/*: any*/),
                      (v67/*: any*/),
                      (v116/*: any*/),
                      (v66/*: any*/),
                      (v117/*: any*/),
                      (v82/*: any*/),
                      (v118/*: any*/),
                      (v119/*: any*/),
                      (v85/*: any*/),
                      (v120/*: any*/),
                      (v121/*: any*/),
                      (v123/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v53/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v129/*: any*/)
                ],
                "storageKey": null
              },
              (v130/*: any*/),
              (v133/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sellerItems",
            "args": (v112/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "PdpSharedSellerItemsCarousel_sellerItems",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          {
            "alias": null,
            "args": (v135/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v27/*: any*/),
                      (v45/*: any*/),
                      (v94/*: any*/),
                      (v106/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v115/*: any*/),
                      (v25/*: any*/),
                      (v67/*: any*/),
                      (v116/*: any*/),
                      (v66/*: any*/),
                      (v117/*: any*/),
                      (v82/*: any*/),
                      (v118/*: any*/),
                      (v119/*: any*/),
                      (v85/*: any*/),
                      (v120/*: any*/),
                      (v121/*: any*/),
                      (v123/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v53/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v129/*: any*/)
                ],
                "storageKey": null
              },
              (v130/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v132/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v131/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v135/*: any*/),
            "filters": [
              "seller",
              "itemId",
              "useML"
            ],
            "handle": "connection",
            "key": "PdpRespRefetchableSimilarItemsGrid_moreLikeThisItem",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          (v15/*: any*/),
          (v53/*: any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v65/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v61/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v76/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurementUnit",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowSellerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": (v136/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "childPrograms",
                                    "plural": true,
                                    "selections": (v136/*: any*/),
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "gdprDisplayInfo",
                "kind": "LinkedField",
                "name": "gdprDisplayInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "countryCode",
                        "variableName": "userCountryCode"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isGdprApplicable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "marketingOptInMessage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "detectFeedbackLanguage",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "detectFeedbackLanguage"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
              }
            ]
          },
          {
            "condition": "fetchChat",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "shippingAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayCityStateCountry",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PresenceResults",
                            "kind": "LinkedField",
                            "name": "presence",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recentOnlineDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerPreferences",
                            "kind": "LinkedField",
                            "name": "sellerPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showOnlineStatus",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUnavailable",
                        "storageKey": null
                      },
                      (v118/*: any*/),
                      {
                        "alias": "buyerChatDisplayInfo",
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "kind": "LinkedField",
                        "name": "displayInfo",
                        "plural": false,
                        "selections": (v81/*: any*/),
                        "storageKey": null
                      },
                      (v98/*: any*/),
                      (v99/*: any*/)
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "presenceFeatureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "presence"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"presence\")"
              },
              {
                "alias": "readReceiptsFeatureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "readReceipts"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"readReceipts\")"
              },
              {
                "alias": null,
                "args": (v110/*: any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v91/*: any*/),
                      (v109/*: any*/)
                    ],
                    "concreteType": "Conversation",
                    "kind": "LinkedField",
                    "name": "buyerItemConversation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasMessageFromSeller",
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUnreadMessageForMember",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMember",
                        "kind": "LinkedField",
                        "name": "originalBuyer",
                        "plural": false,
                        "selections": (v59/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "transaction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "sku",
                            "plural": false,
                            "selections": (v59/*: any*/),
                            "storageKey": null
                          },
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrderFeedback",
                            "kind": "LinkedField",
                            "name": "orderFeedback",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "token",
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Member",
                        "kind": "LinkedField",
                        "name": "sellerMember",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastConversationReadDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "userType",
                                "value": "BUYER"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "translatedTextBody",
                            "storageKey": "translatedTextBody(userType:\"BUYER\")"
                          },
                          (v53/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textBody",
                            "storageKey": null
                          },
                          (v137/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDateFormatted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fromUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shipmentTrackingNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "anchors",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sourceType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionRequestedNetPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadePrivateOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadeNetPriceOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMadeOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionAutomatedPrivateOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionSpecialShippingRequests",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionRequestedHold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldPlaced",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldReleased",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionShippingQuoteRequested",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCallInitiated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCustomizationOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionCustomization",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionBundledOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionPrivateOfferShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionPrivateOfferHoldSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionHoldShippingQuoteSent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionInternalAdminJoined",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionMarkedShipped",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnRequested",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnApproved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnDeclinedApproved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnCompleted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionReturnDeclined",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionDealerCounterOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actionBuyerCounterOffer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "kind": "LinkedField",
                            "name": "offer",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isApoFromCart",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expirationDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExpired",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSubmitted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRevisedByDealer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCountered",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "amountPerItem",
                                "plural": false,
                                "selections": [
                                  (v122/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCanceled",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "mostRecentOffer",
                                "plural": false,
                                "selections": (v59/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TransactionSummaryObject",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "offerDiscountPercentage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": (v59/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v65/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Summary",
                        "kind": "LinkedField",
                        "name": "conversationSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unread",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "conversations",
                    "args": (v138/*: any*/),
                    "concreteType": "ConversationsSolrConnection",
                    "kind": "LinkedField",
                    "name": "conversationsSolr",
                    "plural": false,
                    "selections": [
                      (v130/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationsSolrEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestMessage",
                                "storageKey": null
                              },
                              (v137/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inboxImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfMessages",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v37/*: any*/),
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "skuPhotoWebPath",
                                    "args": (v83/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestMessageReceivedAt",
                                "storageKey": null
                              },
                              {
                                "alias": "hasReplied",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isLatestMessageSender",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "originalBuyer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasUnreadTag",
                                    "storageKey": null
                                  },
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v129/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v133/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "conversations",
                    "args": (v138/*: any*/),
                    "filters": [
                      "page",
                      "buyerId"
                    ],
                    "handle": "connection",
                    "key": "BuyerChatVariant_conversations",
                    "kind": "LinkedHandle",
                    "name": "conversationsSolr"
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplayAndNotBot",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "guestId"
                  },
                  (v92/*: any*/),
                  (v109/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "minItems",
                    "value": 5
                  },
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v64/*: any*/)
                ],
                "concreteType": "SponsoredItems",
                "kind": "LinkedField",
                "name": "sponsoredItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SponsoredItemsMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "itemId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "impressionTrackerLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clickTrackerLink",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v37/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v27/*: any*/),
                      (v106/*: any*/),
                      (v45/*: any*/),
                      (v94/*: any*/),
                      (v115/*: any*/),
                      (v25/*: any*/),
                      (v67/*: any*/),
                      (v116/*: any*/),
                      (v66/*: any*/),
                      (v117/*: any*/),
                      (v82/*: any*/),
                      (v118/*: any*/),
                      (v119/*: any*/),
                      (v85/*: any*/),
                      (v120/*: any*/),
                      (v121/*: any*/),
                      (v123/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/537.0.0-2025-11-18T19:15:26.609Z/PdpRespUnavailableLayoutEntryQuery",
    "metadata": {},
    "name": "PdpRespUnavailableLayoutEntryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3067b23ff6ecb183d300727d1a72fe23";

export default node;
